import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { PAGE_NUMBER, PAGE_SIZE } from 'src/app/shared/constants/utils.constants';
import { OrganizationsService } from 'src/app/shared/services/organizations.service';
import { searchOrganization } from 'src/app/shared/models/oarganization';
import { updateFlag } from 'src/app/shared/models/organizations';
import { updateOrganization } from 'src/app/shared/models/organizations';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';

@Component({
  selector: 'app-organizations',
  templateUrl: './organizations.component.html',
  styleUrls: ['./organizations.component.scss']
})
export class OrganizationsComponent implements OnInit {

  isSuperAdmin: boolean = true;
  organizationName: any;
  isLoading: boolean = false;
  isActive: boolean = true;
  searchControl = new FormControl(null);
  dropdownOptions: string[] = ['GROK', 'SCHOOL', 'COLLEGE', 'INDUSTRY'];
  dropdownStatus: string[] = ['Active', 'In Active'];
  list: any;
  isSortOrg: boolean = true;
  filteredOrganizations: any;
  currentUser: any
  organizationType: any;
  is_active: boolean = null;
  userPermissions: string[];
  sortBy = {
    ORGANIZATION_NAME: "organization_name",
  }


  constructor(
    private router: Router,
    private toasterService: ToastrService,
    private organizationService: OrganizationsService,
    private sessionStorageService: SessionStorageService,

  ) {
    this.isSuperAdmin = window.location.href.includes('/admin/');
  }

  ngOnInit(): void {
    this.userPermissions = sessionStorage.getItem("userPermissions").split(","); 
    this.sortfilterColumn();
    this.currentUser = this.sessionStorageService.getUsername();
  }

  createOrg() {
    if (this.isSuperAdmin) {
      console.log("if");
      this.router.navigateByUrl('/admin/create-org')
    } else {
      console.log("else");
      this.router.navigateByUrl('/ide/create-lab')
    }
  }

  onChangeOrgType(event: any) {
    if (event.target.value != "") {
      this.organizationType = event.target.value;
    } else {
      this.organizationType = null;
    }
    this.sortfilterColumn();
  }

  onChangeStatus(event: any) {
    console.log(event.target.value);

    if (event.target.value === "Active") {
      this.is_active = true
    }
    else if (event.target.value === "In Active") {
      this.is_active = false
    }
    else if (event.target.value === "") {
      this.is_active = null;
    }
    this.sortfilterColumn();
  }

  applyFilter(event: Event) {
    const filterValue = ((event.target as HTMLInputElement).value).toLowerCase();
    this.sortfilterColumn('', '', filterValue, PAGE_SIZE, PAGE_NUMBER)
  }

  editOrg(org: any) {
    console.log(org.orgId);
    if (this.isSuperAdmin && this.userPermissions.includes('edit_organization')) {
      this.router.navigateByUrl(`/admin/edit-org/${org.orgId}`);
    }
  }

  async status(item: any) {
    console.log(item);
    if(this.userPermissions.includes('edit_organization')){
      this.isLoading = true
      try {
        const payload: updateFlag = {
          isActive: !item.isActive,
          userName: this.currentUser,
          organizationId: item.organizationId
        };
        const result: any = await this.organizationService.update(payload).toPromise();
        if (result) {
          this.sortfilterColumn();
          this.toasterService.success("Organization updated successfully");
        }
      }
      catch (err: any) {
        console.log(err, "error");
        this.isLoading = false;
        if (err.status == 403) {
          // showForbiddenError(this.toasterService);
          this.toasterService.error(`${err.error.message}`);
        }
        else {
          this.toasterService.error(`${err.error.message}`);
        }
      }
    }
  }
  

  async dataCaptureEnabled(item: any){
    if(this.userPermissions.includes('edit_organization')){
      this.isLoading = true
      try {
        const payload: updateFlag = {
          isDataCaptureEnabled: !item.isDataCaptureEnabled,
          userName: this.currentUser,
          organizationId: item.organizationId
        };
        const result: any = await this.organizationService.update(payload).toPromise();
        if (result) {
          this.sortfilterColumn();
          this.toasterService.success("Organization updated successfully");
        }
      }
      catch (err: any) {
        console.log(err, "error");
        this.isLoading = false;
        if (err.status == 403) {
          this.toasterService.error('You don’t have permission to perform this action');
        }
        else {
          this.toasterService.error(`${err.error.message}`);
        }
      }
    }else{
      this.toasterService.error('You don’t have permission to perform this action');
      console.log('You don’t have permission to perform this action');
    }
  }

  async dataVisualizationEnabled(item: any){
    if(this.userPermissions.includes('edit_organization')){
      this.isLoading = true
      try {
        const payload: updateFlag = {
          isDataVisualizationEnabled: !item.isDataVisualizationEnabled,
          userName: this.currentUser,
          organizationId: item.organizationId
        };
        const result: any = await this.organizationService.update(payload).toPromise();
        if (result) {
          this.sortfilterColumn();
          this.toasterService.success("Organization updated successfully");
        }
      }
      catch (err: any) {
        console.log(err, "error");
        this.isLoading = false;
        if (err.status == 403) {
          this.toasterService.error('You don’t have permission to perform this action');
        }
        else {
          this.toasterService.error(`${err.error.message}`);
        }
      }
    }else{
      this.toasterService.error('You don’t have permission to perform this action');
      console.log('You don’t have permission to perform this action');
    }
  }

  sortfilterColumn(sortByName?: any, sortOrder?: any, value?: any, pageSize?: number, pageNumber?: number) {
    this.isLoading = true;
    const getOrganization: any = {} as searchOrganization;
    getOrganization.pageSize = Number(pageSize ? pageSize : PAGE_SIZE);
    getOrganization.pageNumber = pageNumber ? pageNumber : PAGE_NUMBER;
    getOrganization.orgName = this.organizationName ? this.organizationName : null;
    getOrganization.orgType = this.organizationType ? this.organizationType : null;
    getOrganization.isActive = this.is_active ? true : (this.is_active === false ? false : null);
    getOrganization.searchString = value ? value : this.searchControl.value;
    getOrganization.orderBy = [
      {
        sortBy: sortByName ? sortByName : "organization_name",
        sortOrder: sortOrder ? sortOrder : "ASC"
      }
    ]
    this.organizationService.search(getOrganization).subscribe((response: any) => {
      console.log(response.organizations);
      this.list = response.organizations;
      this.filteredOrganizations = this.list;
      this.isLoading = false;
    },
      (error: any) => {
        this.isLoading = false;
        if (error.status == 403) {
          this.toasterService.error(`${error.error.message}`);
        }
      }
    )
  }

}
